<template>
  <div class="row px-2 d-flex flex-row">
    <div class="" :style="{ maxWidth: '900px' }">
      <h6>
        <span v-if="usesQ4">{{ buildTitle() }}</span
        ><span v-else>
          {{ question.title }}
        </span>
      </h6>
    </div>

    <div class="">
      <div
        @mouseenter="openTooltip"
        @mouseleave="closeTooltip"
        :style="{
          width: 20 + 'px',
          height: 20 + 'px',
          cursor: 'default',
          maxWidth: '800px',
        }"
        class="
          ml-1
          rounded-circle
          text-center
          align-top
          bgnscblue
          small
          infohover
        "
      >
        <b> ? </b>
      </div>
      <span
        :id="avg"
        :style="{ position: 'fixed' }"
        class="border rounded bgnscblue p-2 small transit"
        >{{ tooltip }}</span
      >
    </div>
  </div>
  <div class="d-flex flex-row-reverse"></div>

  <div class="row">
    <div class="col-1"></div>
    <apexchart
      width="200%"
      type="bar"
      :options="options"
      :series="legendTitles"
    ></apexchart>
  </div>
</template>
  <script>
import store from "../../store";
export default {
  props: ["benchmark", "question", "data", "avg", "tooltip"],
  setup() {},
  data: function () {
    return {
      usesQ4: this.question.usesQ4 ? true : false,
      popover: false,
      options: {
        responsive: [
          {
            breakpoint: "425px",
            options: {
              yaxis: {
                labels: {
                  style: {
                    fontSize: "6px",
                  },
                },
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "6px",
                  },
                },
              },
            },
          },
        ],
        chart: {
          type: "bar",
          height: "350px",
          width: "700px",
          stacked: true,
          stackType: "100%",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        grid: {
          show: false,
          borderColor: "#90A4AE",
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          categories: this.makeCategories(),
          axisBorder: {
            show: false,
          },
          labels: {
            show: false,
            cssClass: "apexcharts-xaxis-label",
            style: {
              fontSize: "12px",
            },
          },
          tickAmount: 1,
          tickPlacement: "between",
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return `${val} respondents`;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          offsetX: 40,
        },
        colors: this.chooseColors(this.benchmark[0].length),
      },
      legendTitles: this.makeSeries(this.makeLegend()),
    };
  },
  methods: {
    openTooltip(event) {
      this.popover = true;
      let x = event.clientX;
      let y = event.clientY;
      let tooltip = document.getElementById(`${this.avg}`);
      tooltip.classList.toggle("transit");

      tooltip.style.zIndex = 99;
      tooltip.style.left = x + 15 + "px";
      tooltip.style.top = y + 15 + "px";
    },
    closeTooltip() {
      let tooltip = document.getElementById(`${this.avg}`);
      tooltip.classList.toggle("transit");

      this.popover = false;
    },
    showModal(modal, data) {
      store.showModal(modal, data);
    },
    hideModal() {
      store.hideModal();
    },
    findCategories(question) {
      let obj = {};
      for (let key in question) {
        obj[`cat${key}`] = this.categoryTrim(question[key].q);
      }
      return obj;
    },
    categoryTrim(str) {
      return str.lastIndexOf("(") > 0
        ? str.slice(0, str.lastIndexOf("(")).trim()
        : str.lastIndexOf("?") > 0
        ? str.slice(0, str.lastIndexOf("?")).trim()
        : str.trim();
    },
    makeSeries(obj) {
      let bench = this.benchmark;

      // console.log(length)
      let mapper = Object.values(obj).map((x, i) => {
        let temp = [];

        for (let ele in bench[i]) {
          temp.push(bench[i][ele]);
        }
        // console.log(temp)
        return { name: x, data: temp };
      });
      // console.log(mapper)
      return mapper;
      // console.log( Object.values(obj).map((x,i)=> {return{name:x,data:Object.values(bench[i])}}))
    },
    makeLegend() {
      let keys = Object.keys(this.question.responses.options);
      if (keys.length > 3) {
        keys.pop();
      }
      return keys.map((x) =>
        this.categoryTrim(this.question.responses.options[x])
      );
    },
    makeCategories() {
      let keys = Object.keys(this.question.responses.questions);
      return keys.map((x) =>
        this.categoryTrim(this.question.responses.questions[x].q)
      );
    },
    chooseColors(int) {
      return int < 4
        ? ["#00843e", "#006bab", "#72bf44"]
        : ["#003a5c", "#046938", "#006bab", "#00843e", "#72bf44", "#6dcff6"];
    },
    buildTitle() {
      return `${this.question.title[0]} your company ${this.question.title[1]}`;
    },
  },
};
</script>
  